<style>
.v-text-field input {
  font-size: 0.75em;
}
</style>
<template>
  <div>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-flower</v-icon>
          PERMISOS
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="busqueda"
          @click:append="cargarLista()"
          @keyup.enter="cargarLista()"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-2"
        >
        </v-text-field>
        <v-spacer></v-spacer>
        <!-- <v-checkbox
          class="mt-2"
          v-model="incInac"
          label="Incluir inactivos"
          @keyup.enter="cargarLista()"
          @change="cargarLista()"
          single-line
        >
        </v-checkbox> -->
      </v-toolbar>
      <v-toolbar flat color="white">
        <v-btn color="primary" small @click="abrirForm(null)">
          <v-icon>mdi-plus</v-icon>
          Nuevo permiso
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :options.sync="options"
        hide-default-footer
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.opcion="{ item }">
          <v-btn icon color="green" title="editar" @click="abrirForm(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon color="red" title="borrar" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:footer>
          <v-pagination
            class="mt-10"
            v-model="currentPage"
            :length="pageCount"
            @input="handlePageChange"
            total-visible="10"
          ></v-pagination>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogPermiso" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <v-icon class="mx-1">mdi-account-key</v-icon>
          <span class="headline">Permiso</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formPermiso">
              <v-row>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    v-model="datosPermiso.DESCRIPCION"
                    label="Nombre"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarPermiso">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;
            <v-btn small @click="dialogPermiso = !dialogPermiso">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "PermisosComponent",

  components: {},
  data: () => ({
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Codigo", value: "PERMISO_ID" },
      { text: "Permiso", value: "DESCRIPCION" },
    ],

    lista: [],
    options: {},
    notifications: false,
    busqueda: null,
    datosPermiso: { PERMISO_ID: "", DESCRIPCION: "" },

    itemsPerPage: 20,
    pageCount: 1,
    totalItems: 0,
    currentPage: 1,

    dialogPermiso: false,
    lectura: true,

    timeout: 5000,
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user", "months"]),

    ...mapGetters("access", []),
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    cargarLista() {
      this.setLoadingTable(true);
      this.setUrl("api/lista-permisos");
      this.requestApi({
        method: "GET",
        data: {
          pageCount: this.pageCount,
          itemsPerPage: this.itemsPerPage,
          page: this.currentPage,
          sortBy: this.options.sortBy[0],
          sortDesc: this.options.sortDesc[0],
          inactivos: this.incInac,
          bus_nombre: this.busqueda,
        },
      })
        .then((res) => {
          this.lista = res.data.lista;
          this.pageCount = res.data.pageCount;
          this.totalItems = res.data.totalItems;
          //console.log(this.totalItems);
        })
        .catch(() => {})
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    abrirForm(permiso) {
      this.dialogPermiso = true;
      if (permiso === null) {
        this.datosPermiso = { PERMISO_ID: "", DESCRIPCION: "" };
        return false;
      }
      this.setLoadingTable(true);
      this.setUrl("api/permiso");
      this.requestApi({
        method: "GET",
        data: {
          permiso_id: permiso.PERMISO_ID,
        },
      })
        .then((res) => {
          this.datosPermiso = res.data[0];
          this.setLoadingTable(false);
        })
        .catch(() => {
          this.setLoadingTable(false);
        })
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    guardarPermiso() {
      this.setUrl("api/guardar-permiso");
      this.requestApi({
        method: "POST",
        data: {
          descripcion: this.datosPermiso.DESCRIPCION,
          permiso_id: this.datosPermiso.PERMISO_ID,
        },
      })
        .then((res) => {
          this.alertNotification({
            param: {
              html: "Permiso guardado",
              timer: 3000,
            },
          });
          this.dialogPermiso = false;
          this.cargarLista();
          //console.log(res.data.datosFinca)
        })
        .catch(() => {
          this.alertNotification({
            param: {
              html: res.data.msg,
              timer: 3000,
              icon: "error",
              title: "Error",
            },
          });
        })
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    borrar(item) {
      this.setUrl("api/borrar-permiso");
      this.requestApi({
        method: "POST",
        data: {
          permiso_id: item.PERMISO_ID,
        },
      })
        .then((res) => {
          this.alertNotification({
            param: {
              html: "Permiso borrado",
              timer: 3000,
            },
          });
          this.cargarLista();
          //console.log(res.data.datosFinca)
        })
        .catch(() => {
          this.alertNotification({
            param: {
              html: res.data.msg,
              timer: 3000,
              icon: "error",
              title: "Error",
            },
          });
        })
        .then(() => {
          this.setLoadingTable(false);
        });
    },

    handlePageChange() {
      this.cargarLista();
    },
  },
  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Permisos");
  },
  watch: {
    options: {
      handler() {
        this.cargarLista();
      },
      deep: true,
    },
  },
};
</script>
